export default "__VITE_ASSET__Ca3aYG6W__"